import { TextInput } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'

import { useFeature } from 'hooks'
import { useFormValidation } from '../../../../providers'
import { useFormStateContext } from '../../../../providers/FormStateContext'
import { messages } from './messages'
import { validateFunction } from './validation'

interface Props {
  name: string
}

export function NameInput(props: Props) {
  const { name } = props
  const { $t } = useIntl()
  const { form, readOnly } = useFormStateContext()

  const { getFeature } = useFeature()

  const skipNameLengthValidation = getFeature('skip_name_length_validation')

  useFormValidation<string>('promotion-name', {
    fieldName: name,
    validateFn: validateFunction(name, Boolean(skipNameLengthValidation)),
  })

  return (
    <TextInput
      autoComplete="off"
      name={name}
      // @ts-expect-error Property 'disabled' does not exist on type 'IntrinsicAttributes & InheritedProps$6 & FormFieldProps' (typings error)
      disabled={readOnly}
      label={$t(messages.label)}
      state={form}
    />
  )
}
